module.exports = __webpack_public_path__ + "static/img/tst2-10-1.1121b0b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-10-1.gif
// module id = UahR
// module chunks = 1